import React from "react";
import RSVPStatusComponent from "../Components/CardView/RSVPStatusComponent";
import { Box } from "@mui/material";

const RSVPStatusPage = () => {
    return (
      <Box sx={{ display: "block" }}>
         <RSVPStatusComponent/>
      </Box>
    );
  };
  
  export default RSVPStatusPage;